import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/pro-solid-svg-icons';

export interface WalletCardAdPromoViewProps {
    promotionalText: string;
    /**
     * 'inline' - wallet list view style (top border line)
     * 'card' - card details view style (white bg, grey border, rounded)
     */
    variant?: 'inline' | 'card';
}

/**
 * Wallet Card Ad view for gift card only brands (non-affiliate)
 * Displays promotional text from Contentful
 */
export function WalletCardAdPromoView({
    promotionalText,
    variant = 'inline',
}: WalletCardAdPromoViewProps) {
    const baseClasses = 'flex items-center justify-center gap-2 w-full';
    const variantClasses =
        variant === 'card'
            ? 'bg-white border border-[#D7D7D7] rounded-[10px] px-5 py-3 my-2'
            : 'px-5 py-3 border-t border-[#BABBBC]';

    return (
        <div className={`${baseClasses} ${variantClasses}`}>
            <FontAwesomeIcon icon={faTags} className="text-[#067647] text-[20px] shrink-0" />
            <p className="font-['Open_Sans'] font-semibold text-[16px] text-[#424344] leading-[1.5] text-left">
                {promotionalText}
            </p>
        </div>
    );
}
